// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Correlator = void 0;
const tslib_1 = require("tslib");
const async_hooks_1 = require("async_hooks");
const uuid = tslib_1.__importStar(require("uuid"));
const asyncLocalStorage = new async_hooks_1.AsyncLocalStorage();
class Correlator {
    static setId() {
        const id = uuid.v4();
        asyncLocalStorage.enterWith(id);
        return id;
    }
    static run(work, ...args) {
        const id = asyncLocalStorage.getStore() || uuid.v4();
        return asyncLocalStorage.run(id, () => work(...args));
    }
    static runWithId(id, work, ...args) {
        id = id ? id : uuid.v4();
        return asyncLocalStorage.run(id, () => work(...args));
    }
    static getId() {
        const store = asyncLocalStorage.getStore();
        return store !== null && store !== void 0 ? store : "";
    }
}
exports.Correlator = Correlator;
//# sourceMappingURL=correlator.js.map